export enum TabsDirection {
  Forward = "forward",
  Backward = "backward"
}
